import { fetcher } from '@commenda/utils';
import { TaskParty, TaskStatus } from '@prisma/client';

export async function createTask({
  data,
}: {
  data: {
    title: string;
    type: 'CONFIRMATION_TASK';
    companyId: number;
    serviceRequestId?: string;
    taskGroupId?: number;
    status?: TaskStatus;
    pendingOn?: TaskParty;
    legacyServiceRequestTaskTaskId?: string;
    legacyServiceRequestTaskOrderNumber?: number;
  };
}) {
  try {
    const res = await fetcher(
      'tasks',
      {
        method: 'POST',
        body: data,
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
